module.exports = __webpack_public_path__ + "img/ico_number_down.a98acf62.svg";